module.exports = __webpack_public_path__ + "img/blis5.8381bccb.png";